"use strict";

Dropzone.autoDiscover = false;
Popper.Defaults.modifiers.computeStyle.enabled = false;
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

$(function() {

    // Start up the theme code
    $(document).ready(function() {
        var ksSidebar = $('.ks-sidebar');

        // // Replace default dropdown logic for sidebar
        ksSidebar.find('.dropdown-toggle').on('click', function() {
            if ($(this).closest('.dropdown-menu').length) {
                if ($(this).closest('.dropdown-menu').find('.dropdown.open > .dropdown-toggle')[0] != $(this)[0]) {
                    $(this).closest('.dropdown-menu').find('.dropdown.open').removeClass('open');
                }

                $(this).closest('.dropdown').toggleClass('open');
            } else {
                if ($('.ks-sidebar .dropdown.open > .dropdown-toggle')[0] != $(this)[0]) {
                    $('.ks-sidebar .dropdown.open').removeClass('open');
                }

                $(this).closest('.dropdown').toggleClass('open');
            }
        });
    });

    // Modifications to the datatables library to add classes to the search box
    $.extend( $.fn.dataTableExt.oStdClasses, {
        "sFilterInput": "form-control input-sm",
    });

    $(document).on("click", ".destroyconfirm", function() {
        var that = this;
        $.confirm({
            title: 'Are you sure?',
            content: 'Are you sure you want to delete this record?',
            buttons: {
                confirm: {
                    text: 'Yes',
                    btnClass: 'btn-info',
                    action: function () {
                        showProcessing();
                        $.ajax({
                            type: "DELETE",
                            url: $(that).attr("data-route"),
                            success: function(result) {
                                hideProcessing();
                                location.reload();
                            },
                            fail: function () {
                                hideProcessing();
                                showAjaxException();
                            }
                        });
                    }
                },
                cancel: {
                    text: 'No',
                    btnClass: 'btn-default',
                    action: function () {

                    }
                }
            }
        });
    });

    $(document).on("click", ".releaseconfirm", function() {
        var that = this;
        $.confirm({
            title: 'Are you sure?',
            content: 'Are you sure you want to release this product?',
            buttons: {
                confirm: {
                    text: 'Yes',
                    btnClass: 'btn-info',
                    action: function () {
                        showProcessing();
                        $.ajax({
                            type: "POST",
                            url: $(that).attr("data-route"),
                            success: function(result) {
                                hideProcessing();
                                $.alert({
                                    title: 'Success',
                                    content: 'Product has been queued for release'
                                });
                            },
                            fail: function () {
                                hideProcessing();
                                showAjaxException();
                            }
                        });
                    }
                },
                cancel: {
                    text: 'No',
                    btnClass: 'btn-default',
                    action: function () {

                    }
                }
            }
        });
    });

    $(document).on("click", ".destroyconfirm_cm", function() {
        var that = this;
        $.confirm({
            title: 'Are you sure?',
            content: 'Are you sure you want to delete this record?',
            buttons: {
                confirm: {
                    text: 'Yes',
                    btnClass: 'btn-info',
                    action: function () {
                        showProcessing();
                        $.ajax({
                            type: "DELETE",
                            url: $(that).attr("data-route"),
                            success: function(result) {
                                hideProcessing();
                                document.location.href = '/category_modules';
                            },
                            fail: function () {
                                hideProcessing();
                                showAjaxException();
                            }
                        });

                    }
                },
                cancel: {
                    text: 'No',
                    btnClass: 'btn-default',
                    action: function () {

                    }
                }
            }
        });
    });

    $(document).on("click", ".destroyconfirm_pm", function() {
        var that = this;
        $.confirm({
            title: 'Are you sure?',
            content: 'Are you sure you want to delete this record?',
            buttons: {
                confirm: {
                    text: 'Yes',
                    btnClass: 'btn-info',
                    action: function () {
                        showProcessing();
                        $.ajax({
                            type: "DELETE",
                            url: $(that).attr("data-route"),
                            success: function(result) {
                                hideProcessing();
                                document.location.href = '/page_modules';
                            },
                            fail: function () {
                                hideProcessing();
                                showAjaxException();
                            }
                        });

                    }
                },
                cancel: {
                    text: 'No',
                    btnClass: 'btn-default',
                    action: function () {

                    }
                }
            }
        });
    });

    $(document).on("submit", "form.throttle", function() {
        $(this).find('input[type=submit]').attr('disabled','disabled');
        showProcessing();
        return true;
    });

    $('#quicksearch-modifier').select2({width: '90px', minimumResultsForSearch: Infinity});

});
function triggerModal(message, title, callback) {
    // hide all modals
    hideProcessing();
    $('.modal').modal('hide');
    $('#modal_ajax-message .modal-body').html(message);
    $('#modal_ajax-message .modal-title').html(title);
    $('#modal_ajax-message .callback').on('click', function(){
        console.log('cierres perimetrales');
        location.reload();
        return false;
    });
    $('#modal_ajax-message').modal();

}
function showAjaxException(messages, title, callback) {
    messages = messages ? messages : ["We're sorry, there has been a communications problem between your browser \
        and the server. Please try reloading the page and trying again."];

    var message_html = '<ul>';
    for (var i = 0; i < messages.length; ++i) {
        message_html += '<li>' + messages[i] + '</li>';
    }
    message_html += '</ul>';

    title = title ? title : 'Communication Problem';
    triggerModal(message_html, title, callback);
}
window.showAjaxException = showAjaxException;

function showProcessing() {
    $("#processing").show();
}
window.showProcessing = showProcessing;

function hideProcessing() {
    $("#processing").hide();
}
window.hideProcessing = hideProcessing;

// function initSelect(el, title) {
//     $(el).selectpicker({
//         "style" : 'btn-default btn-sm',
//         "menuStyle" : 'dropdown-inverse',
//         "title" : title
//     });
//     return true;
// }

// Used by Typeahead.js
var substringMatcher = function(strs) {
    return function findMatches(q, cb) {
        var matches, substringRegex;

        // an array that will be populated with substring matches
        matches = [];

        // regex used to determine if a string contains the substring `q`
        var substrRegex = new RegExp(q, 'i');

        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        $.each(strs, function(i, str) {
            if (substrRegex.test(str.value)) {
                // the typeahead jQuery plugin expects suggestions to a
                // JavaScript object, refer to typeahead docs for more info
                matches.push({ value: str.value, data: str.data });
            }
        });

        cb(matches);
    };
};
window.substringMatcher = substringMatcher;

$(document).on("click", ".productthumbnail", function() {
    if ($(this).find("img")) {
        $.confirm({
            title: '',
            content: '<img src="'+$(this).find('img').attr("src")+'" class="rounded img-fluid mt-1">',
            animation: 'zoom',
            animationClose: 'top',
            backgroundDismiss: true,
            buttons: {
                okay: {
                    text: 'Close',
                    btnClass: 'btn-info'
                }
            }
        });
    }
});

$(document).on("click", ".backtotop", function() {
    $("html, body").animate({ scrollTop: 0 }, "fast");
    return false;
});
$(document).ajaxError(function(event, jqxhr, settings, exception) {
    if (exception == 'Unauthorized') {
        // Redirect
        document.location.href = '/signin';
    }
});

// Selectproduct modal/control
function showSelectproduct(tag) {
    var event = new CustomEvent('selectproduct.'+tag+':show');
    document.dispatchEvent(event);

    $('#modal_selectproduct').data('tag', tag);

    // Show the modal
    $('#modal_selectproduct .selectproduct_input .icon-addon').hide();
    $('#modal_selectproduct .selectproduct_input input').val('');
    $("#modal_selectproduct").modal();
}
window.showSelectproduct = showSelectproduct;

$(function () {

    function selectproductSearch(query, syncResults, asyncResults) {
        if (query == '') {
            return;
        }
        return $.ajax({
            type: "post",
            url: "/search",
            data: {
                query: query
            },
            success: function(response) {
                asyncResults(response.results);
            }
        });
    }
    var debouncedSelectproduct = _.debounce(selectproductSearch, 1000);
    window.selectproductSearch = selectproductSearch;

    $('#modal_selectproduct .selectproduct_input .typeahead').typeahead(
        {
            hint: true,
            highlight: true,
            minLength: 3
        },
        {
            templates: {
                empty: [
                    '<div>No Results Found</div>'
                ].join('\n'),
                suggestion: function(data) {
                    return '<div><strong>'+ data.name +'</strong> (PCSID: '+data.id+')'+(data.sku ? ' (SKU: '+data.sku+')' : '')+'</div>';
                }
            },
            display: function(data) {
                return data.name +' (PCSID: '+data.id+')'+(data.sku ? ' (SKU: '+data.sku+')' : '');
            },
            source: function (query, syncResults, asyncResults) {
                debouncedSelectproduct(query, syncResults, asyncResults);
            }
        }
    )
    .bind('typeahead:select', function(event, suggestion) {
        var tag = $('#modal_selectproduct').data('tag');

        // Fire an event when a product has been selected
        var newEvent = new CustomEvent('selectproduct.'+tag+':selected', {'detail': suggestion});

        document.dispatchEvent(newEvent);
        $("#modal_selectproduct").modal('hide');
    })
    .bind('typeahead:asyncrequest', function(event, query, dataset) {
        $('#modal_selectproduct .selectproduct_input .icon-addon').show();
    })
    .bind('typeahead:asynccancel', function(event, query, dataset) {
        $('#modal_selectproduct .selectproduct_input .icon-addon').hide();
    })
    .bind('typeahead:asyncreceive', function(event, query, dataset) {
        // Called when all done
        $('#modal_selectproduct .selectproduct_input .icon-addon').hide();
    });

    $("#modal_selectproduct .selectproduct_cancel").on("click", function() {
        // Reset the child id
        $('#modal_selectproduct .selectproduct_input input').val('');
        $("#modal_selectproduct").removeAttr('data-id');
    });

    $('.flatpickr').flatpickr({dateFormat: "d F, Y"});
    $('.flatpickr-time').flatpickr({dateFormat: "Y-m-d H:i:00", enableTime: true, time_24hr: true, altInput: true, altFormat: "d F Y H:i:00" });

});

$(function () {
    $(".badge-checkbox").click(function(){
        if ($(this).children('input').is(':checked')) {
            $(this).addClass('badge-checkbox-checked');
        }else{
            $(this).removeClass('badge-checkbox-checked');
        }
    });
    $(".ks-sidebar-wrapper").hover(
        function () {
            $(".ks-sidebar-position-fixed").addClass('ks-sidebar-compact-open');
        },
        function () {
            $(".ks-sidebar-position-fixed").removeClass('ks-sidebar-compact-open');
        }
    );
    $(window).bind("resize", function () {
        if ($(this).width() < 1300) {
            $('.ks-sidebar-default').addClass('ks-sidebar-compact')
        } else {
            $('.ks-sidebar-default').removeClass('ks-sidebar-compact');
        }
    }).trigger('resize');
});

$(function() {
    $('.datepicker').datetimepicker({
        format: 'YYYY-MM-DD',
        ignoreReadonly: true
    })
    $('.datetimepicker').datetimepicker({
        format: 'YYYY-MM-DD h:mm:ss A',
        ignoreReadonly: true
    })
})

// New Components - Non Product Pages Vanilla JS Implementation
$(function() {             
    // Initialize JSON Editor
    function instJSONEditor(el, value){          
        var editor = CodeMirror.fromTextArea(el, {            
            mode: {name:"javascript", json: true},
            lineNumbers: true,
            lineWrapping: true,
            gutters: ['CodeMirror-lint-markers', 'CodeMirror-linenumbers'],
            tabSize: 4,
            lint: true,            
            matchBrackets: true,
            matchTags: true,
            autoCloseBrackets: true,
            autoCloseTags: true,
            extraKeys: {"Ctrl-Space":"autocomplete"},
            autoRefresh: true                      
        });        
        editor.refresh();
        editor.getDoc().setValue(value);        
    }
    let jsonEditors = document.getElementsByClassName('json-content');    
    
    if(jsonEditors.length < 1){
        return;
    }    
    let jsonEditorValues = [].map.call(jsonEditors, function(el) {                                     
        if(el.attributes.value === undefined){                        
            return instJSONEditor(el, '');
        } else {
            let value = el.attributes.value.value;           
            return instJSONEditor(el, value);
        }             
    });
    
    // // Initialize Markup Editor
    function instMarkupEditor(el, value){        
        if(value === 'undefined' || value === null){
            value = '';
        }
        var easyMDE = new EasyMDE({
            element: el, 
            autoFocus: true,
            hideIcons: ['fullscreen', 'side-by-side'], 
            forceSync: true,
            initialValue: value
        });        
        easyMDE.value(value);
        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            easyMDE.codemirror.refresh();
        })
    }
    let markupEditors = document.getElementsByClassName('markdown-content');
    let markupEditorsValues = [].map.call(markupEditors, function(el) {
        if(el.attributes.value === undefined){
            return instMarkupEditor(el, '');
        } else {
            let value = el.attributes.value.value;
            return instMarkupEditor(el, value);
        }
    })
})